export default __webpack_public_path__ + "static/media/calendar.4f1e4b22.svg";